import { useParams } from "react-router-dom";
import { FacilityPermissionsTable } from "./_FacilityPermissionsTable";

export default function FacilityPeoplePermissionsPage() {
  const { facilityId } = useParams();

  return <FacilityPermissionsTable facilityId={facilityId!} />;
}
